module.exports = __webpack_public_path__ + "static/media/WhiteB2.2df563fe.jpg";